export const getRequestHeaders = () => {
  const myToken = localStorage.getItem("token");
  return {
    headers: { Authorization: `Bearer ${myToken}` },
  };
};

export const getSchoolNameFromAbbreviation = (abbreviation) => {
  switch (abbreviation.toLowerCase()) {
    case "mma":
      return "Mountainside Music Academy";
    case "lsma":
      return "Lakeside Music Academy";
    case "tma":
      return "Treeside Music Academy";
    case "tsma":
      return "Treeside Music Academy";
    case "mor":
      return "Morningside Music Academy";
    case "psma":
      return "Parkside Music Academy";
    default:
      return "our Music Academy";
  }
}
